// extracted by mini-css-extract-plugin
module.exports = {"switch":"UnitSwitch_switch__9RfLe","option":"UnitSwitch_option__KAIgD","active":"UnitSwitch_active__C_IPi"};